import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  LayoutDashboard,
  Calculator,
  FileText,
  LogOut,
  Bell,
  MessageSquare
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export const DashboardSidebar = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut(() => navigate('/login'));
  };

  return (
    <aside className="w-64 bg-[#222222] border-r border-white/10 min-h-screen p-4 flex flex-col fixed left-0 top-0 z-50">
      <div className="flex flex-col flex-1">
        <div className="mb-8">
          <img 
            src="/lovable-uploads/f90447f3-bb25-46e2-adea-7e5de86942c0.png" 
            alt="Trade Co Logo" 
            className="h-12 mx-auto mb-4"
          />
          <h2 className="text-xl font-semibold text-center text-white">Welcome</h2>
        </div>
        
        <nav className="flex-1">
          <div className="space-y-2">
            <Link 
              to="/dashboard"
              className="flex items-center gap-2 px-4 py-2 text-gray-300 hover:bg-white/10 hover:text-white rounded-lg transition-colors duration-200 relative"
            >
              <LayoutDashboard className="h-5 w-5" />
              <span>Start Here</span>
            </Link>

            <Link 
              to="/dashboard/overview"
              className="flex items-center gap-2 px-4 py-2 text-gray-300 hover:bg-white/10 hover:text-white rounded-lg transition-colors duration-200 relative"
            >
              <LayoutDashboard className="h-5 w-5" />
              <span>Overview</span>
            </Link>

            <Link 
              to="/calculator"
              className="flex items-center gap-2 px-4 py-2 text-gray-300 hover:bg-white/10 hover:text-white rounded-lg transition-colors duration-200 relative"
            >
              <Calculator className="h-5 w-5" />
              <span>Calculator</span>
            </Link>

            <Link 
              to="/documents"
              className="flex items-center gap-2 px-4 py-2 text-gray-300 hover:bg-white/10 hover:text-white rounded-lg transition-colors duration-200 relative"
            >
              <FileText className="h-5 w-5" />
              <span>Documents</span>
            </Link>

            <Link 
              to="/chat"
              className="flex items-center gap-2 px-4 py-2 text-gray-300 hover:bg-white/10 hover:text-white rounded-lg transition-colors duration-200 relative"
            >
              <MessageSquare className="h-5 w-5" />
              <span>Chat</span>
            </Link>

            <Link 
              to="/notifications"
              className="flex items-center gap-2 px-4 py-2 text-gray-300 hover:bg-white/10 hover:text-white rounded-lg transition-colors duration-200 relative"
            >
              <Bell className="h-5 w-5" />
              <span>Notifications</span>
            </Link>
          </div>
        </nav>

        <div className="mt-auto pt-4">
          <Button
            variant="ghost"
            className="w-full justify-start text-gray-300 hover:bg-white/10 hover:text-white transition-colors duration-200"
            onClick={handleSignOut}
          >
            <LogOut className="mr-2 h-4 w-4" />
            Sign out
          </Button>
        </div>
      </div>
    </aside>
  );
};

export default DashboardSidebar;